module.exports = __webpack_public_path__ + "media/images/touch/homescreen96-cd5d17fa0a5c41d937eb7efabe63a57f.png";